import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MontenegroFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15545'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15545)'>
				<rect
					width='20'
					height='14'
					fill='#E6BE53'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0.953125 12.0667C0.953125 12.619 1.40084 13.0667 1.95312 13.0667H18.0484C18.6006 13.0667 19.0484 12.619 19.0484 12.0667V1.93335C19.0484 1.38107 18.6006 0.93335 18.0484 0.93335H1.95313C1.40084 0.93335 0.953125 1.38106 0.953125 1.93335V12.0667Z'
					fill='#E01826'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.58742 2.46821C9.12474 2.61935 8.98721 3.20732 9.33485 3.54801C9.45609 3.66682 9.61908 3.73337 9.78883 3.73337H10.2115C10.3813 3.73337 10.5443 3.66682 10.6655 3.54801C11.0132 3.20732 10.8756 2.61935 10.4129 2.46821L10.2072 2.401C10.0727 2.35706 9.92768 2.35706 9.79317 2.401L9.58742 2.46821ZM10.4668 4.67609C10.2076 4.93012 9.79278 4.93012 9.53357 4.67609L9.524 4.66671L8.82409 3.9808C8.67277 3.83251 8.44442 3.7957 8.25418 3.88892L8.21796 3.90667C7.92576 4.04984 7.86303 4.43896 8.09542 4.66671L8.69798 5.25721C8.90613 5.4612 8.95765 5.77674 8.82521 6.03634L8.59926 6.47919C8.58109 6.5148 8.57161 6.55422 8.57161 6.5942C8.57161 6.78145 8.37532 6.90386 8.20718 6.82147L7.96702 6.70379C7.79729 6.62062 7.76085 6.39459 7.89585 6.26229C8.00541 6.15492 8.00541 5.97849 7.89585 5.87112L7.68492 5.66442C7.64142 5.62178 7.60512 5.57237 7.57743 5.51811L7.17681 4.7329C7.15437 4.68891 7.13688 4.64256 7.12468 4.59471L7.00669 4.13221C6.86905 3.59264 6.16972 3.44962 5.83129 3.89184L5.37553 4.48737C5.28651 4.60368 5.23828 4.74607 5.23828 4.89254V6.37313C5.23828 6.47846 5.26324 6.58229 5.31111 6.67611L5.665 7.36974C5.69776 7.43396 5.74073 7.49244 5.79222 7.5429L6.59009 8.32481C6.64094 8.37464 6.69944 8.41601 6.76337 8.44733L7.57561 8.84533C7.60431 8.85939 7.63585 8.86671 7.66781 8.86671C7.88983 8.86671 7.95937 9.1667 7.76001 9.26439L7.65355 9.31656C7.63082 9.3277 7.61002 9.3424 7.59194 9.36012L7.38114 9.56671C7.24887 9.69633 7.03722 9.69633 6.90495 9.56671C6.77268 9.43708 6.56102 9.43708 6.42876 9.56671L6.3947 9.60009C6.2733 9.71906 6.24324 9.9031 6.32049 10.0545L6.4813 10.3697C6.59517 10.5929 6.82458 10.7334 7.07514 10.7334H7.46468C7.56637 10.7334 7.66671 10.7101 7.75802 10.6654L8.38654 10.3574C8.50668 10.2985 8.60448 10.2023 8.66528 10.0831L8.86011 9.70126C8.95318 9.51884 9.19651 9.47911 9.34278 9.62244C9.44767 9.72524 9.46389 9.8884 9.38128 10.0098L8.95365 10.6384C8.74382 10.9469 8.82792 11.3675 9.14023 11.5715L9.63555 11.8951C9.8571 12.0399 10.1433 12.0399 10.3648 11.8951L10.8601 11.5715C11.1724 11.3675 11.2566 10.9469 11.0467 10.6384L10.6191 10.0098C10.5365 9.8884 10.5527 9.72524 10.6576 9.62244C10.8039 9.47911 11.0472 9.51884 11.1403 9.70126L11.3351 10.0831C11.3959 10.2023 11.4937 10.2985 11.6138 10.3574L12.2424 10.6654C12.3337 10.7101 12.434 10.7334 12.5357 10.7334H12.9252C13.1758 10.7334 13.4052 10.5929 13.5191 10.3697L13.6799 10.0545C13.7571 9.9031 13.7271 9.71906 13.6057 9.60009L13.5716 9.56671C13.4393 9.43708 13.2277 9.43708 13.0954 9.56671C12.9632 9.69633 12.7515 9.69633 12.6192 9.56671L12.4084 9.36012C12.3904 9.3424 12.3696 9.3277 12.3468 9.31656L12.2404 9.26439C12.041 9.1667 12.1105 8.86671 12.3326 8.86671C12.3645 8.86671 12.3961 8.85939 12.4248 8.84533L13.237 8.44733C13.3009 8.41601 13.3594 8.37464 13.4103 8.32481L14.2082 7.5429C14.2596 7.49244 14.3026 7.43396 14.3354 7.36974L14.6893 6.67611C14.7371 6.58229 14.7621 6.47846 14.7621 6.37313V4.89254C14.7621 4.74607 14.7139 4.60368 14.6248 4.48737L14.1691 3.89184C13.8306 3.44962 13.1313 3.59264 12.9937 4.13221L12.8757 4.59471C12.8635 4.64256 12.846 4.68891 12.8236 4.7329L12.4229 5.51811C12.3953 5.57237 12.359 5.62178 12.3154 5.66442L12.1045 5.87112C11.995 5.97849 11.995 6.15492 12.1045 6.26229C12.2395 6.39459 12.2031 6.62062 12.0333 6.70379L11.7932 6.82147C11.625 6.90386 11.4288 6.78145 11.4288 6.5942C11.4288 6.55422 11.4193 6.5148 11.4011 6.47919L11.1752 6.03634C11.0427 5.77674 11.0942 5.4612 11.3024 5.25721L11.9049 4.66671C12.1373 4.43896 12.0746 4.04984 11.7824 3.90667L11.7462 3.88892C11.5559 3.7957 11.3276 3.83251 11.1763 3.9808L10.4764 4.66671L10.4668 4.67609Z'
					fill='#E6BE53'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.04688 7.93333C9.04688 8.10792 9.33978 8.16679 9.42603 8.01498C9.59234 7.72223 9.7958 7.46666 9.99926 7.46666C10.2027 7.46666 10.4062 7.72223 10.5725 8.01498C10.6587 8.16679 10.9516 8.10792 10.9516 7.93333C10.9516 7.16013 10.5252 6.53333 9.99926 6.53333C9.47327 6.53333 9.04688 7.16013 9.04688 7.93333Z'
					fill='#215F90'
				/>
			</g>
		</svg>
	);
};

export default MontenegroFlagIcon;
